import { Medico } from '../../models/Entities/Turnero';
import { CommonState } from '../common/state/commonState';

export interface TurneroMedicosState extends CommonState<Medico> {
    current: Medico | undefined;
    configuracion: Record<number, Record<string, unknown>>;

    isLoadingConfig: boolean;
    successLoadingConfig: boolean | undefined;
    failOnLoadingConfig: boolean;
}

export const TurneroMedicosUnloadState: any = {
    // loading all
    isLoadingAll: false,
    isLoadingAllSuccess: undefined,
    FailGettingAll: false,

    // updating all
    isUpdatingAll: false,
    isUpdatingAllSuccess: undefined,
    FailUpdatingAll: false,

    // loading one
    isLoadingOne: false,
    isLoadingOneSuccess: undefined,
    FailGettingOne: false,

    // updating
    isUpdatingOne: false,
    successUpdatingOne: undefined,
    failOnUpdatingOne: false,
    
    // adding
    isAddingNewOne: false,
    successAddingNewOne: undefined,
    failOnAddingNewOne: false,

    // deleting
    isDeletingOne: false,
    isDeletingOneSuccess: undefined,
    FailDeletingOne: false,

    // list and error
    list: [],
    error: undefined,

    // custom
    current: undefined,
    configuracion: {},

    isLoadingConfig: false,
    successLoadingConfig: undefined,
    failOnLoadingConfig: false
};
